var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 43.137 43.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_728",
    "data-name": "\\u7EC4 728",
    transform: "translate(-3269.689 -396.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_727",
    "data-name": "\\u7EC4 727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_332",
    "data-name": "\\u8DEF\\u5F84 332",
    d: "M3289.909,396.271h2.7a2.358,2.358,0,0,0,.325.069,20.538,20.538,0,0,1,9.367,2.979,21.291,21.291,0,0,1,10.2,14.8c.146.783.222,1.579.331,2.369v2.7c-.035.277-.073.553-.1.83a21.623,21.623,0,0,1-17.709,19.056c-.8.145-1.6.225-2.409.335h-2.7c-.526-.065-1.054-.121-1.579-.2a21.62,21.62,0,0,1-18.306-17.615c-.145-.8-.225-1.606-.335-2.41v-2.7c.062-.513.115-1.028.187-1.54a21.61,21.61,0,0,1,17.708-18.355C3288.354,396.462,3289.134,396.379,3289.909,396.271Zm-7.752,23.822a4.784,4.784,0,0,0,1.14,1.921,5.093,5.093,0,0,0,3.466,1.539,10.292,10.292,0,0,1-7.148,2.094,2.074,2.074,0,0,0,.378.273,13.815,13.815,0,0,0,6.9,1.883,13.364,13.364,0,0,0,10.469-4.457,14.167,14.167,0,0,0,3.742-9.791.944.944,0,0,1,.368-.768c.641-.6,1.233-1.26,1.84-1.9a1.229,1.229,0,0,0,.148-.246l-2.513.685-.062-.112a4.961,4.961,0,0,0,1.958-2.487c-.922.323-1.832.636-2.738.964a.514.514,0,0,1-.593-.155,4.924,4.924,0,0,0-8.146,2.424,14.758,14.758,0,0,0-.184,2.315,14.1,14.1,0,0,1-10.059-5.146,4.784,4.784,0,0,0-.645,2.92,5,5,0,0,0,2.066,3.613l-.067.114-2.024-.568c-.257,1.9,1.32,3.936,3.745,4.885Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterOutlined);
export default __webpack_public_path__ + "static/media/twitter_outlined.e50cfc01e9444215ff8590275c360bb7.svg";
export { ForwardRef as ReactComponent };